import { get, first } from 'lodash';
import {
    ACTIVATION_BRIEF_STATUS_ACCEPTED,
    ACTIVATION_BRIEF_STATUS_COMPLETE
} from '../../../../constants/activation-brief';
import { ACTIVATION_TASK_STATUS_COMPLETE } from '../../../../constants/activation-task';

export default {
    props: {
        brief: {
            type: Object,
            required: true
        }
    },
    computed: {
        canAddAdditionalOrders() {
            const statusCondition = [ACTIVATION_BRIEF_STATUS_ACCEPTED, ACTIVATION_BRIEF_STATUS_COMPLETE].includes(
                this.brief.status
            );
            const allowMultipleOrdersCondition = this.brief.allow_multiple_orders;
            let requireTasksCompletedCondition = true;

            let incompleteTasks = null;
            if (this.brief.require_tasks_completion_for_new_orders && this.brief.tasks) {
                incompleteTasks = this.brief.tasks.filter(
                    (task) => task.status !== ACTIVATION_TASK_STATUS_COMPLETE && task.is_selected
                );
                requireTasksCompletedCondition = !incompleteTasks.length;
            }

            return statusCondition && allowMultipleOrdersCondition && requireTasksCompletedCondition;
        },
        findExistingOrders() {
            return get(this, 'brief.orders') || [];
        },
        hasExistingOrder() {
            return this.numberOfOrders > 0;
        },
        findExistingOrder() {
            return first(this.findExistingOrders);
        },
        numberOfOrders() {
            return this.findExistingOrders.length;
        }
    },
    methods: {
        mapOrderItems(key) {
            if (!this.hasExistingOrder) {
                return [];
            }
            return this.findExistingOrder.items.map((item) => item[key]);
        }
    }
};
